// src/pages/AboutUsPage.jsx
import React from 'react';

const AboutUsPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-semibold text-gray-900 mb-6">About Us</h1>
      <p className="text-gray-700 mb-4">
        Connecting Global Suppliers with Canadian Builders
      </p>
      <p className="text-gray-700 mb-4">
        Namsan Bro is an enterprise B2B platform designed to bridge global suppliers and Canadian architects, contractors, and developers.
      </p>
      <p className="text-gray-700 mb-4">
        Our mission is to create a seamless ecosystem where verified suppliers from around the world can provide high-quality materials, products, and solutions directly to Canadian professionals.
      </p>
      <p className="text-gray-700 mb-4">
        We focus on fostering transparent, efficient, and reliable trade partnerships through verified business registration, MoQ-based wholesale transactions, compliance with Canadian import and safety regulations, and streamlined logistics and payment solutions.
      </p>
      <p className="text-gray-700 mb-4">
        Namsan Bro aims to redefine how global trade connects with the Canadian construction and design market — empowering innovation, collaboration, and sustainable growth.
      </p>
    </div>
  );
};

export default AboutUsPage;
